// extracted by mini-css-extract-plugin
export default {"info":"about_info_foIXK","socialMedia":"about_socialMedia_vLsO_","iconContainer":"about_iconContainer_x94wm","icon":"about_icon_8Qeng"};